var chunkMapping = {
	"0": [
		4607
	],
	"3": [
		4004,
		4539
	],
	"79": [
		5043
	],
	"164": [
		5130
	],
	"165": [
		5131
	],
	"168": [
		5134
	],
	"169": [
		5135
	],
	"170": [
		5136
	],
	"171": [
		5137
	],
	"172": [
		5138
	],
	"173": [
		5139
	],
	"174": [
		5140
	],
	"175": [
		5141
	],
	"176": [
		5142
	],
	"177": [
		5143
	],
	"178": [
		5144
	],
	"179": [
		5145
	],
	"180": [
		5146
	],
	"181": [
		5147
	],
	"182": [
		5148
	],
	"183": [
		5149
	],
	"184": [
		5150
	],
	"185": [
		5151
	],
	"186": [
		5152
	],
	"187": [
		5153
	]
};
var idToExternalAndNameMapping = {
	"4004": [
		"default",
		"./nuorder-components",
		3688
	],
	"4539": [
		"default",
		"./helios-components",
		3688
	],
	"4607": [
		"default",
		"./Containers",
		3598
	],
	"5043": [
		"default",
		"./OrderlessInvoices",
		3598
	],
	"5130": [
		"default",
		"./AsyncEventTracker",
		3598
	],
	"5131": [
		"default",
		"./HostWrapper",
		3598
	],
	"5134": [
		"default",
		"./CheckoutV3",
		3598
	],
	"5135": [
		"default",
		"./CheckoutConfirmation",
		3598
	],
	"5136": [
		"default",
		"./ContactCreditCards",
		3598
	],
	"5137": [
		"default",
		"./AuditDialog",
		3598
	],
	"5138": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3598
	],
	"5139": [
		"default",
		"./InvoiceDialog",
		3598
	],
	"5140": [
		"default",
		"./PaymentDueModal",
		3598
	],
	"5141": [
		"default",
		"./PaymentModal",
		3598
	],
	"5142": [
		"default",
		"./PaymentHistory",
		3598
	],
	"5143": [
		"default",
		"./PaymentConfigurations",
		3598
	],
	"5144": [
		"default",
		"./PaymentPreferences",
		3598
	],
	"5145": [
		"default",
		"./ManagePaymentProcessing",
		3598
	],
	"5146": [
		"default",
		"./MobilePaymentsWrapper",
		3598
	],
	"5147": [
		"default",
		"./PayPage",
		3598
	],
	"5148": [
		"default",
		"./Challenge",
		3598
	],
	"5149": [
		"default",
		"./ManagePaymentMethods",
		3598
	],
	"5150": [
		"default",
		"./LightspeedReports",
		3598
	],
	"5151": [
		"default",
		"./ActivateLightspeedPayments",
		3598
	],
	"5152": [
		"default",
		"./MarketingLandingPage",
		3598
	],
	"5153": [
		"default",
		"./ShippingPromotionsListContainer",
		3598
	]
};
var idToRemoteMap = {
	"4004": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3688
		}
	],
	"4539": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3688
		}
	],
	"4607": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5043": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5134": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5146": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5147": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5148": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5149": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5150": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5151": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5152": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5153": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}